import _ from 'lodash';

const callAPI = ({ dispatch, getState}) => next => action => {
    const {
        types,
        apiCall,
        predicate = () => true,
        payload = {},
        onSuccess = {},
        data
    } = action;

    if (!types) return next(action);

    if (
        !Array.isArray(types) ||
        types.length !== 3 ||
        !types.every(type => typeof type === 'string')
    ) {
        throw new Error('Expected an array of three string types.');
    }

    if (typeof apiCall !== 'function') {
        throw new Error('Expected apiCall to be a function');
    }

    if (!predicate(getState())) return Promise.resolve();

    const [requestType, successType, failureType] = types;

    dispatch(_.assign({}, payload, {
        type: requestType,
        data
    }));

    return apiCall().then(
        response => {
            dispatch(_.assign({}, payload, onSuccess, {
                response,
                type: successType,
                data
            }));
            return response;
        },
        error => dispatch(_.assign({}, payload, {
            error,
            type: failureType,
            data
        }))
    );
};

export default callAPI;